import React from 'react'
import ResumePostion from '../../Components/ResumePosition'
import Stripe from '../../Components/Stripe'

// Update title to register page view with analytics
import useDocumentTitle from '../../Utilities/useDocumentTitle'

function Other() {
  useDocumentTitle('Experience - Other')
  const otherPositionsArray = [
    {
      title: 'Manager',
      dates: 'Mar 2016 - Jan 2018',
      company: 'Sughrue Mion, PLLC',
      location: 'Washington, DC',
      bullets: [
        'Managed a team of 20 paralegals responsible for $5 million in annual revenue.',
        'Developed protocols for ensuring compliance with regulatory filing deadlines.'
      ]
    },
    {
      title: 'Patent Procecution Coordinator',
      dates: 'Jan 2012 - Feb 2016',
      company: 'Sughrue Mion, PLLC',
      location: 'Washington, DC',
      bullets: [
        'Owned day to day department operations including review and assignment on incoming tasks and docketing compliance efforts.',
        'Provided continued learning, development and training to specialists.'
      ]
    },
    {
      title: 'Patent Prosecution Specialist',
      dates: 'Aug 2008 - Dec 2012',
      company: 'Sughrue Mion, PLLC',
      location: 'Washington, DC',
      bullets: [
        'Prepared and filed new U.S. Patent Applications with the U.S. Patent and Trademark Office.',
        'Communicated updates and application status to international clients, while reviewing and responding to all inquiries and requests.'
      ]
    }
  ]
  let experience = otherPositionsArray.map((item, i) => {
    return <ResumePostion key={i} props={item} />
  })
  return (
    <div className='experience-section my-4'>
      <h5 className='text-center'>Summary</h5>
      <p className='text-center'>
        Before working in tech, I pursued a 10+ year career with Sughrue Mion,
        PLLC, an intellectual property firm in Washington, DC. During my time
        with the firm, I held several positions rising from Formalities
        Specialist to Manager, responsible for two independent teams employing
        20+ specialists.
      </p>
      <Stripe />
      <div className='row'>
        <div className='col-md-6'>{experience}</div>
        <div className='col-md-6'>
          <img
            src={require('../../Media/washington.jpg')}
            className='img-fluid'
            alt='DC rowhouses'
          />
        </div>
      </div>
      <Stripe />
    </div>
  )
}

export default Other
